import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/removeUser.tsx
var RemoveUser = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M16.5672 11.5001H21.75M12.9392 7.00006C12.9392 8.93306 11.3149 10.5001 9.31125 10.5001C7.30758 10.5001 5.68329 8.93306 5.68329 7.00006C5.68329 5.06706 7.30758 3.50006 9.31125 3.50006C11.3149 3.50006 12.9392 5.06706 12.9392 7.00006ZM2.50451 17.3622C3.79087 15.054 6.2239 13.5001 9.31125 13.5001C12.3986 13.5001 14.8316 15.054 16.118 17.3622C16.9857 18.9192 15.5021 20.5001 13.6697 20.5001H4.95277C3.12037 20.5001 1.6368 18.9192 2.50451 17.3622Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M5.55286 7.00006C5.55286 4.51478 7.5306 2.50006 9.97027 2.50006C12.4099 2.50006 14.3877 4.51478 14.3877 7.00006C14.3877 9.48534 12.4099 11.5001 9.97027 11.5001C7.5306 11.5001 5.55286 9.48534 5.55286 7.00006Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M2.39108 18.3528C3.52634 15.2258 6.31691 13.0001 9.97031 13.0001C13.6237 13.0001 16.4143 15.2258 17.5495 18.3528C17.8503 19.1813 17.6459 19.9954 17.1659 20.5781C16.696 21.1485 15.9664 21.5001 15.1761 21.5001H4.76449C3.97421 21.5001 3.24458 21.1485 2.77474 20.5781C2.29475 19.9954 2.09028 19.1813 2.39108 18.3528Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M16.5964 11.0001C16.1898 11.0001 15.8601 11.3358 15.8601 11.7501C15.8601 12.1643 16.1898 12.5001 16.5964 12.5001H21.0138C21.4204 12.5001 21.75 12.1643 21.75 11.7501C21.75 11.3358 21.4204 11.0001 21.0138 11.0001H16.5964Z",
			fill: "currentColor"
		})
	] })
});
//#endregion
export { RemoveUser };
